// extracted by mini-css-extract-plugin
module.exports = {"container":"searchStorage_container__9SVZR","content":"searchStorage_content__1Z6VL"};